import { pairsApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useFuturesPairs = () => {
  return useQuery([QUERIES.FUTURES_PAIRS], () => pairsApi.get());
};
